import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Modal,
  TextField,
  Typography,
  Divider,
  Chip,
  Card,
  CardContent,
  CardHeader,
  Autocomplete
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import "../card.css";
import { Cancel, CheckCircle } from "@mui/icons-material";
import { toast } from "sonner";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(26, 32, 39, 0.5)"
      : "rgba(255, 255, 255, 0.2)",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  borderRadius: "8px",
}));

const DashboardWidgets = ({ isOnline }) => {
  const [widget_name, setWidget_name] = useState("");
  const [selected_flows, setSelected_flows] = useState([]);
  const [open_flow, setOpen_flow] = useState(false);
  const [all_flows, setAll_flows] = useState([]);
  const [all_widgets, setAll_widgets] = useState([]);
  const [editing_mode, setEditing_mode] = useState(false);
  const [editing_id, setEditing_id] = useState(null);
  const [wid_color, setWid_color] = useState('black');

  const handleEditing = (item) => {
    setWidget_name(item.widget_name);
    setEditing_mode(true);
    const arry = item?.flow_sources.map(flow => flow.id)
    setSelected_flows(arry)
    setEditing_id(item.id)
    setWid_color(item.color)
  }

  
  function formatDateToYearMonthDay(date) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    let suffix = "th";

    if (day === 1 || day === 21 || day === 31) {
      suffix = "st";
    } else if (day === 2 || day === 22) {
      suffix = "nd";
    } else if (day === 3 || day === 23) {
      suffix = "rd";
    }

    return `${day}${suffix} ${month} ${year}`;
  }

  const close_modal = () => {
    setSelected_flows([]);
    setWidget_name("");
    setOpen_flow(false);
    setEditing_mode(false);
    setEditing_id(null);
    setWid_color('')
  };

  const createThing = () => {
    const data = {
      name: widget_name,
      data: selected_flows,
      editing_mode: editing_mode,
      editing_id: editing_id,
      color: wid_color
    };

    toast.promise(
      api.post("/dashboards/create/widget", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: editing_mode? "Editing..." : "Creating...",
        success: (response) => {
          close_modal();
          fetch_needs();

          return response.data;
        },
        error: (error) => {
          console.log(error);

          return "An error Occurred, try again later";
        },
      }
    );
  };
  const deleteThing = (id) => {
    toast.promise(
      api.get(`/dashboards/delete/widget/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: "Deleting...",
        success: (response) => {
          fetch_needs();

          return response.data;
        },
        error: (error) => {
          console.log(error);

          return "An error Occured, try again later";
        },
      }
    );
  };

  const toggleFlowSelection = (flowId) => {
    setSelected_flows((prevFlows) =>
        prevFlows.includes(flowId) 
            ? prevFlows.filter(id => id !== flowId)
            : [...prevFlows, flowId]
        );
    };

  const fetch_needs = () => {
    const storedFlows = localStorage.getItem("all_stored_flows");
    const storedWidgets = localStorage.getItem("all_stored_widgets");

    if (!isOnline) {
      setAll_flows(JSON.parse(storedFlows));
      setAll_widgets(JSON.parse(storedWidgets));
    } else {
      api
        .get("/dashboards/bring/all/flows", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setAll_flows(response.data?.data);
          localStorage.setItem(
            "all_stored_flows",
            JSON.stringify(response.data?.data)
          );
        })
        .catch(function (error) {
          console.log(error);
        });

      api
        .get("/dashboards/bring/all/widgets", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          setAll_widgets(response.data?.data);
          localStorage.setItem(
            "all_stored_widgets",
            JSON.stringify(response.data?.data)
          );
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    fetch_needs();
  }, []);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 720,
    maxHeight: "80vh",
    overflowY: 'auto', 
    '&::-webkit-scrollbar': {
        width: '7px',
    },
    '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  return (
    <Box>
      <Item>
        <Typography
          variant="h4"
          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
          sx={{ textAlign: "center", color: "darkblue", mb: 2, mt: 2 }}
        >
         <b> {editing_mode? `Edit ${widget_name} Widget` : 'Create Widgets'}</b>
        </Typography>
        <TextField
          size="small"
          fullWidth
          label="Widget Name (Assets, Incomes...)"
          value={widget_name}
          onChange={(e) => setWidget_name(e.target.value)}
          type="text"
        />
        <Autocomplete
          id="tags-outlined"
          options={[
            { color: "Red", id: "red" },
            { color: "Blue", id: "blue" },
            { color: "Orange", id: "orange" },
            { color: "Green", id: "green" },
            { color: "Brown", id: "brown" },
            { color: "Yellow", id: "yellow" },
            { color: "Black", id: "black" },
            { color: "DarkBlue", id: "darkblue" },
          ]}
          sx={{ mt: 2 }}
          getOptionLabel={(option) => option.color}
          isOptionEqualToValue={(option, value) =>
            option.color === value.id
          }
          onChange={(event, value) =>
            setWid_color(value.id)
          }
          filterSelectedOptions
          renderInput={(params) => (
            <TextField
              {...params}
              helperText={`Select Widget Color (current color: ${wid_color})`}
              size="small"
              fullWidth
            />
          )}
        />
        <Box>
          <Button
            variant="contained"
            onClick={() => setWidget_name("")}
            sx={{ backgroundColor: "#bc6c25", color: "#fff", margin: 2 }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            disabled={widget_name === ""}
            onClick={() => setOpen_flow(true)}
            color="success"
          >
            {editing_mode? 'Edit FlowSources' : 'Add FlowSources'}
          </Button>
        </Box>
      </Item>

      <Modal
        open={open_flow}
        onClose={() => setOpen_flow(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            variant="h3"
          >
            {editing_mode? 'Edit ' : null} {widget_name}'s Description
          </Typography>
          <List>
            <Typography
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
              variant="h5"
              color={wid_color}
            >
              <b>Savings Related</b> 
            </Typography>
            {all_flows.map((item) => item.type === 'Savings'? (
                <>
                  <ListItem
                    sx={{ 
                        cursor: 'pointer', 
                        color: selected_flows.includes(item.id) ? "Highlight" : "inherit" 
                    }}
                    key={item.id}
                    alignItems="flex-start"
                    onClick={() => toggleFlowSelection(item.id)}
                    secondaryAction={
                        selected_flows.includes(item.id) ? <CheckCircle /> : null
                    }
                  >
                    <ListItemText
                      primary={item.source}
                      secondary={
                        <Box sx={{ display: "block" }}>
                          <div>
                            <Typography
                              component="span"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              variant="body2"
                              color="text.primary"
                            >
                              <b>Description: {item.description}</b>
                            </Typography>
                          </div>
                        </Box>
                      }
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </>
              ):null)}
              <Typography
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                variant="h5"
                color={wid_color}
              >
                <b>Loans Related</b>
              </Typography>
            {all_flows.map((item) => item.type === 'Loans'? (
                <>
                  <ListItem
                    sx={{ 
                        cursor: 'pointer', 
                        color: selected_flows.includes(item.id) ? "Highlight" : "inherit" 
                    }}
                    key={item.id}
                    alignItems="flex-start"
                    onClick={() => toggleFlowSelection(item.id)}
                    secondaryAction={
                        selected_flows.includes(item.id) ? <CheckCircle /> : null
                    }
                  >
                    <ListItemText
                      primary={item.source}
                      secondary={
                        <Box sx={{ display: "block" }}>
                          <div>
                            <Typography
                              component="span"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              variant="body2"
                              color="text.primary"
                            >
                              <b>Description: {item.description}</b>
                            </Typography>
                          </div>
                        </Box>
                      }
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </>
              ):null)}
              <Typography
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                variant="h5"
                color={wid_color}
              >
                <b>Investments areas</b>
              </Typography>
            {all_flows.map((item) => item.type === 'Investments'? (
                <>
                  <ListItem
                    sx={{ 
                        cursor: 'pointer', 
                        color: selected_flows.includes(item.id) ? "Highlight" : "inherit" 
                    }}
                    key={item.id}
                    alignItems="flex-start"
                    onClick={() => toggleFlowSelection(item.id)}
                    secondaryAction={
                        selected_flows.includes(item.id) ? <CheckCircle /> : null
                    }
                  >
                    <ListItemText
                      primary={item.source}
                      secondary={
                        <Box sx={{ display: "block" }}>
                          <div>
                            <Typography
                              component="span"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              variant="body2"
                              color="text.primary"
                            >
                              <b>Description: {item.description}</b>
                            </Typography>
                          </div>
                        </Box>
                      }
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </>
              ):null)}
              <Typography
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                variant="h5"
                color={wid_color}
              >
                <b>Expenditure Matters</b>
              </Typography>
            {all_flows.map((item) => item.type === 'Expense'? (
                <>
                  <ListItem
                    sx={{ 
                        cursor: 'pointer', 
                        color: selected_flows.includes(item.id) ? "Highlight" : "inherit" 
                    }}
                    key={item.id}
                    alignItems="flex-start"
                    onClick={() => toggleFlowSelection(item.id)}
                    secondaryAction={
                        selected_flows.includes(item.id) ? <CheckCircle /> : null
                    }
                  >
                    <ListItemText
                      primary={item.source}
                      secondary={
                        <Box sx={{ display: "block" }}>
                          <div>
                            <Typography
                              component="span"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              variant="body2"
                              color="text.primary"
                            >
                              <b>Description: {item.description}</b>
                            </Typography>
                          </div>
                        </Box>
                      }
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </>
              ):null)}
              <Typography
                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                variant="h5"
                color={wid_color}
              >
                <b>Trade Related</b>
              </Typography>
            {all_flows.map((item) => item.type === 'Trading'? (
                <>
                  <ListItem
                    sx={{ 
                        cursor: 'pointer', 
                        color: selected_flows.includes(item.id) ? "Highlight" : "inherit" 
                    }}
                    key={item.id}
                    alignItems="flex-start"
                    onClick={() => toggleFlowSelection(item.id)}
                    secondaryAction={
                        selected_flows.includes(item.id) ? <CheckCircle /> : null
                    }
                  >
                    <ListItemText
                      primary={item.source}
                      secondary={
                        <Box sx={{ display: "block" }}>
                          <div>
                            <Typography
                              component="span"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              variant="body2"
                              color="text.primary"
                            >
                              <b>Description: {item.description}</b>
                            </Typography>
                          </div>
                        </Box>
                      }
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </>
              ):null)}
            
          </List>
          <Box>
            <Button
              size="small"
              color="error"
              variant="contained"
              sx={{
                borderRadius: 2,
                m: 1,
                boxShadow:
                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  boxShadow:
                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#14213d",
                },
              }}
              onClick={close_modal}
            >
              Close
            </Button>

            <Button
              size="small"
              color="success"
              variant="contained"
              sx={{
                borderRadius: 2,
                m: 1,
                boxShadow:
                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  boxShadow:
                    "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                  backgroundColor: "#14213d",
                },
              }}
              onClick={createThing}
              disabled={!selected_flows}
            >
              {editing_mode? 'Edit Widget' : 'Create Widget'}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Box sx={{ mt: 5 }}>
        <Item>
          {all_widgets && all_widgets[0] ? (
            <Box
              sx={{
                display:'flex',
                flexWrap: 'wrap',
                maxHeight: "80vh",
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  width: "7px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#888",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#555",
                },
                p: 2,
              }}
            >
              {all_widgets && all_widgets.map((item) => (
                <Card
                  sx={{
                    maxWidth: 340,
                    m: 1,
                    borderRadius: 7,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                    borderStyle: "groove",
                    borderColor: item.color,
                  }}
                  key={item.id}
                >
                  <CardHeader
                    title={
                      <Typography
                        variant="h5"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>{item.widget_name}{editing_mode && editing_id == item.id ?' (currently editing)':null}</b>
                      </Typography>
                    }
                    subheader={
                      <Typography
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="subtitle"
                      >
                        <b>Created on: {formatDateToYearMonthDay(new Date(item.date_created))}</b>
                      </Typography>
                    }
                  />
                  <CardContent>
                    <Box
                      sx={{
                        display: "block",
                        justifyContent: "space-between",
                      }}
                    >
                      {item?.flow_sources && item?.flow_sources.map((flows_in) => (
                        <Box key={flows_in.id}>
                          <Typography  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>
                              {flows_in.source}:{" "}
                              <span style={{ color: item.color }}>{flows_in.description}</span>
                            </b>
                          </Typography>
                          <Divider variant='middle' sx={{ m:1 }} />
                        </Box>
                      ))}
                    </Box>
                    <Box
                      sx={{
                        mt: 2,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography
                        sx={{ display: "inline-flex" }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <Chip
                          sx={{
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                            minWidth: 0,
                            "&:hover": {
                              boxShadow:
                                "0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            },
                          }}
                          size="small"
                          onClick={() => handleEditing(item)}
                          variant="contained"
                          label={<b style={{ color: "darkblue" }}>Edit</b>}
                        />
                      </Typography>
                      <div style={{ marginLeft: "auto" }}>
                        <Chip
                          color="error"
                          variant="outlined"
                          label="Delete"
                          onClick={() => deleteThing(item.id)}
                          deleteIcon={<Cancel />}
                          sx={{
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                            minWidth: 0,
                          }}
                          size="small"
                        />

                        {/* <Chip
                          label="Change Color"
                          sx={{
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                            minWidth: 0,
                          }}
                          size="small"
                        /> */}
                      </div>
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Box>
          ) : (
            <Typography
              sx={{ textAlign: "center", m: 5 }}
              variant="h4"
              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            >
              <b>No widgets available, Create one above...</b>
            </Typography>
          )}
        </Item>
      </Box>
    </Box>
  );
};

export default DashboardWidgets;
